import { array, number, object } from "superstruct";

export const WishlistsBackInStockItemSchema = object({
    productId: number(),
    restockedProductVariants: array(number()),
});
